import { getWindow } from './getWindow';

export const getTheme = () => {
    const window = getWindow();

    return window?.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light';
};
